import { render, staticRenderFns } from "./deckVideoDetail.vue?vue&type=template&id=55243a0a&scoped=true&"
import script from "./deckVideoDetail.vue?vue&type=script&lang=js&"
export * from "./deckVideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./deckVideoDetail.vue?vue&type=style&index=0&id=55243a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55243a0a",
  null
  
)

export default component.exports